// src/components/ModalCarga/ModalCarga.jsx
import React from 'react';
import './ModalCarga.css';

export const ModalCarga = ({ inline = false }) => {
  return (
    <div className={`spinner-backdrop ${inline ? 'inline' : ''}`}>
      <div className="spinner" />
    </div>
  );
};
